import Konva from 'konva'
import { KonvaEventObject } from 'konva/lib/Node'

import { NonEmptyPoint2D, Point2D } from '@ahha/stableComponents/Canvas/types/point'
import { isPlainObject } from '@ahha/utils/@types/typeChecks'

export const isNonEmptyPoint2D = (point: Point2D[]): point is NonEmptyPoint2D => point.length > 0

export const isKonvaEvent = (e: unknown): e is KonvaEventObject<Event> => isPlainObject(e) && e.currentTarget instanceof Konva.Node
